import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute"; // Import the PrivateRoute component
import navitems from "./navitems.json";
import NoPage404 from "./pages/NoPage404";
import Dashboard from "./pages/Dashboard";
import ApplicationForm from "./pages/ApplicationForm";
import LoanProcessing from "./pages/LoanProcessing";
import AddRepayment from "./pages/AddRepayment";
import DailyLoanRepaymentsDetailed from "./pages/DailyLoanRepaymentsDetailed";
import DailyLoanReleasesDetailed from "./pages/DailyLoanReleasesDetailed";
import LoansOutstandingBalanceSheet from "./pages/LoansOutstandingBalanceSheet";
import PastDueAccountsByAccountOfficer from "./pages/PastDueAccountsByAccountOfficer";
import OutstandingBalanceReportPerProduct from "./pages/OutstandingBalanceReportPerProduct";
import OutstandingBalanceReportPerAccountOfficer from "./pages/OutstandingBalanceReportPerAccountOfficer";
import DelinquentAccountReport from "./pages/DelinquentAccountReport";
import OutstandingBalanceReport from "./pages/OutstandingBalanceReport";
import DailyProofsheet from "./pages/DailyProofsheet";
import IncomeStatement from "./pages/IncomeStatement";
import BalanceSheet from "./pages/BalanceSheet";
import TrialBalance from "./pages/TrialBalance";
import LoanListingByLoanStatus from "./pages/LoanListingByLoanStatus";
import PortfolioAtRiskByAging from "./pages/PortfolioAtRiskByAging";
import AmortizationSchedule from "./pages/AmortizationSchedule";
import DisclosureDiscountStatement from "./pages/DisclosureDiscountStatement";
import AuthorityToDeduct from "./pages/AuthorityToDeduct";
import CoMakerStatement from "./pages/CoMakerStatement";
import PromissoryNote from "./pages/PromissoryNote";
import Vouchers from "./pages/Vouchers";
import PersonalConsentAndDeclarationOfBeneficiaryForMortuaryFundContributionProgram from "./pages/PersonalConsentAndDeclarationOfBeneficiaryForMortuaryFundContributionProgram";
import AffidavitIfConsentAndConformityToPPLCsContractualSavingsProgram from "./pages/AffidavitIfConsentAndConformityToPPLCsContractualSavingsProgram";
import AffidavitOfEmployment from "./pages/AffidavitOfEmployment";
import AffidavitOfConfirmationOfATMCardAsAPayrollAccount from "./pages/AffidavitOfConfirmationOfATMCardAsAPayrollAccount";
import AuthorizationForBankAccountInquiry from "./pages/AuthorizationForBankAccountInquiry";
import PastdueAccountFirstNotice from "./pages/PastdueAccountFirstNotice";
import PastdueAccountSecondNotice from "./pages/PastdueAccountSecondNotice";
import RePastdueAccountFinalNoticeBeforeLegalAction from "./pages/RePastdueAccountFinalNoticeBeforeLegalAction";
import DelinquentAccountFirstNotice from "./pages/DelinquentAccountFirstNotice";
import DemandLetter from "./pages/DemandLetter";
import ApplicantPage from "./pages/ApplicantPage";
import LoanPage from "./pages/LoanPage";
import AddUserForm from "./pages/AddUserForm";
import ImportApplicant from "./pages/ImportApplicant";
import ImportLoanProcessing from "./pages/ImportLoanProcessing";
import ImportLoanPayments from "./pages/ImportLoanPayments";
import AssetManagement from "./pages/AssetManagement";
import LiabilityManagement from "./pages/LiabilityManagement";
import IncomeManagement from "./pages/IncomeManagement";
import ExpenseManagement from "./pages/ExpenseManagement";
import EquityManagement from "./pages/EquityManagement";

// Component map for dynamic routing
const componentMap = {
    Dashboard,
    ApplicationForm,
    LoanProcessing,
    AddRepayment,
    DailyLoanRepaymentsDetailed,
    DailyLoanReleasesDetailed,
    LoansOutstandingBalanceSheet,
    PastDueAccountsByAccountOfficer,
    OutstandingBalanceReportPerProduct,
    OutstandingBalanceReportPerAccountOfficer,
    DelinquentAccountReport,
    OutstandingBalanceReport,
    DailyProofsheet,
    IncomeStatement,
    BalanceSheet,
    TrialBalance,
    LoanListingByLoanStatus,
    PortfolioAtRiskByAging,
    AmortizationSchedule,
    DisclosureDiscountStatement,
    AuthorityToDeduct,
    CoMakerStatement,
    PromissoryNote,
    Vouchers,
    PersonalConsentAndDeclarationOfBeneficiaryForMortuaryFundContributionProgram,
    AffidavitIfConsentAndConformityToPPLCsContractualSavingsProgram,
    AffidavitOfEmployment,
    AffidavitOfConfirmationOfATMCardAsAPayrollAccount,
    AuthorizationForBankAccountInquiry,
    PastdueAccountFirstNotice,
    PastdueAccountSecondNotice,
    RePastdueAccountFinalNoticeBeforeLegalAction,
    DelinquentAccountFirstNotice,
    DemandLetter,
    ApplicantPage,
    LoanPage,
    AssetManagement,
    LiabilityManagement,
    IncomeManagement,
    ExpenseManagement,
    EquityManagement,
};

function CustomRoute() {
    return (
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <AuthProvider>
                <Routes>
                    {/* Public Routes */}
                    <Route path="/login" element={<Login />} />
                    <Route path="*" element={<NoPage404 />} />

                    {/* Protected Routes */}
                    <Route
                        path="/"
                        element={
                            <PrivateRoute>
                                <Dashboard />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/register"
                        element={
                            <PrivateRoute>
                                <Register />
                            </PrivateRoute>
                        }
                    />
                    {navitems.map((item, index) => {
                        if (item.slug !== null && item.comp) {
                            const CustomComponent = componentMap[item.comp];
                            return (
                                <Route
                                    path={`/${item.slug}`}
                                    key={index}
                                    element={
                                        <PrivateRoute>
                                            <CustomComponent />
                                        </PrivateRoute>
                                    }
                                />
                            );
                        }
                        return item.subitem?.map((subitem, subIndex) => {
                            if (subitem.slug !== null && subitem.comp) {
                                const SubCustomComponent = componentMap[subitem.comp];
                                return (
                                    <Route
                                        path={`/${subitem.slug}`}
                                        key={subIndex}
                                        element={
                                            <PrivateRoute>
                                                <SubCustomComponent />
                                            </PrivateRoute>
                                        }
                                    />
                                );
                            }
                            return null;
                        });
                    })}
                    <Route
                        path="/users/add"
                        element={
                            <PrivateRoute>
                                <AddUserForm />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/applicant/:id"
                        element={
                            <PrivateRoute>
                                <ApplicantPage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/loans/:id"
                        element={
                            <PrivateRoute>
                                <LoanPage />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/ImportApplicant"
                        element={
                            <PrivateRoute>
                                <ImportApplicant />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/ImportLoanProcessing"
                        element={
                            <PrivateRoute>
                                <ImportLoanProcessing />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/ImportLoanPayments"
                        element={
                            <PrivateRoute>
                                <ImportLoanPayments />
                            </PrivateRoute>
                        }
                    />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default CustomRoute;